<template>
  <div class="opertion_wrap" :style="{'position': $route.path=='/analysis'?'':'relative'}">
    <div class="head">
      <div class="left">
        <!-- 题目ID:{{question.question_id}} -->
        <!-- {{$rands(question.question_id)}} -->
        <div>
          <span class="my_score">
            题目分数: <span style="color: #333;">{{question.question_score}}</span>
          </span>
          <span class="my_score">
            平均得分: <span style="color:#333">{{question.avg_score}}</span>
          </span>
          <span class="my_score">
            我的得分: <span style="color:#f2413a">{{question.user_score}}</span>
          </span>
        <!-- </div> -->
          <div v-if="question.auto_judge == 0">
          <!-- <span class="my_score">
            排名: <span style="color:#333">{{question.rank}}</span>
          </span> -->
          <span v-if="parseFloat(question.user_score) != 0" class="my_score">
            打败人数: <span style="color:#333">{{question.percent}}%</span>
          </span>
          </div>
          <div v-else>
          <span class="my_score">
            正确人数: <span style="color:#333">{{question.correct_number}}%</span>
          </span>
          <span class="my_score">
            错误人数: <span style="color:#333">{{question.error_number}}%</span>
          </span>
          </div>
        </div>
      </div>
      <div class="right">
        <span class="img_warp">
          <div style="align-items: center;display: flex;flex-direction: column;" v-if="userInfo.show_discuss == 1">
          <img src="@/assets/icons/发帖子.png"
               @click="addDiscuss"
               alt=""
               v-if="userInfo.show_discuss == 1">
               <div >发帖</div>
               </div>
                   <div style="align-items: center;display: flex;flex-direction: column;">
          <img src="@/assets/icons/jc.png"
               @click="feed"
               alt="">
                   <div >反馈</div>
               </div>
                <div style="align-items: center;display: flex;flex-direction: column;"     v-if="!question.has_favorite">
          <img  src="@/assets/icons/收藏.png"

               @click="collect"
               alt="">
                   <div >收藏</div>
               </div>
                <div  v-else style="align-items: center;display: flex;flex-direction: column;">
          <img src="@/assets/icons/收藏实心.png"

               @click="cancelCollect"
               alt="">
                   <div >已收藏</div>
               </div>
        </span>
      </div>
    </div>
    <div class="content"
         :style="{'height':`calc(100% - ${opertion_heigth?360:100}rem)`}">
      <div class="coll_wrap">
        <el-collapse v-model="activeNames"
                     @change="handleChange">

          <el-collapse-item title="题目内容"
                            v-if="$route.path == '/self_correct'"
                            name="1">

                 <div class="title">
           <span class="topic_id">
              题目ID：{{question.question_id}}
            </span>
            <span class="topic_id2">题目{{question.paper_question_no}} ({{question.question_type_name}}:{{question.question_score}}分，{{question.source_name}})</span>

          </div>
            <div v-if="question.question_head_content"
                 class="topic"
                 v-html="question.question_head_content"></div>
            <div class="topic"
                 v-html="question.question_content"></div>
          </el-collapse-item>
          <el-collapse-item title="题目解析"

                            name="2">
            <div class="topic"
                 v-html="question.question_explain"></div>
          </el-collapse-item>

          <el-collapse-item title="我的答案"
                            name="4">

                <div class="img_wrap"
                v-if="question.auto_judge == 0&&$route.path !== '/self_correct' "
         v-for="(item, index) in (
  Array.isArray(images)
    ? images
    : typeof images === 'string' && images.trim() !== ''
      ? JSON.parse(images)
      : []
)"
           :key="index+item">

        <div style="font-size: 28rem;width:50rem" v-show="!Array.isArray(images)&&(question.paper_question_no==index )">{{index}} </div>
        <div v-if="Array.isArray(item)"
             class="img_card">
          <div v-for="(img,imgindex) in item"
          style="margin-right: 10rem;"
               :key="imgindex">
            <el-image class="answer"
            v-show="question.paper_question_no==index"
                      :src="$addAllHeader(img)"
                      :preview-src-list="$addForHeader(item)">
            </el-image>
          </div>
        </div>
        <div v-else>

          <el-image class="answer"
          v-show="$route.path !== '/self_correct'"
                    :src="$addAllHeader(item)"
                    :preview-src-list="[...item]">
          </el-image>
        </div>
      </div>
            <div class="topic"
             v-if="question.auto_judge !== '0'"
                 v-html="question.user_answer"> </div><img src="@/assets/self_correct/Vector.png"
       v-if="question.question_score== question.user_score&&question.auto_judge != 0"
               alt="">
                   <div class="topic"
              v-if="!question.user_answer&&question.auto_judge !== 0 "
                 >无数据 </div>
                  <div class="topic"
              v-if=" question.auto_judge == '0'&&$route.path == '/self_correct' "
                 >见左半页  </div>
          </el-collapse-item>
          <el-collapse-item title="我的评语"
                            v-if="$route.path == '/analysis'"
                            name="5">
            <div class="topic">
              {{question.comment_to_user?question.comment_to_user:'无数据'}}
            </div>
          </el-collapse-item>
           <el-collapse-item title="题目答案"
                            name="3">
            <div class="topic"
                 v-html="question.question_answer"></div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
    <div class="fixed_btn"
         v-if="opertion_heigth"
         :style="{'height':`${opertion_heigth}rem`}">
      <div class="line">
        <div class="label">
          本题得分（{{question.question_score}}分）
        </div>
        <div class="input_wrap">
          <el-input-number
            v-model="userScore"
            @change="handleChange"
            :min="0"
            :max="Number(question.question_score)"
            :disabled="question.auto_judge == 1"
            label="label"></el-input-number>
        </div>
      </div>
      <div class="line" v-if="question.question_type_id!==62">
        <div class="label">
          自评
        </div>
        <div class="input_wrap">
          <el-input style="width:calc(100% - 100rem);placeholder:请输入评价"
                    :disabled="question.auto_judge == 1"
                    v-model="question.comment_to_user" />
        </div>
      </div>
      <div class="line">
        <!-- <div class="label">
          <img src="@/assets/self_correct/上一题.png"
               @click="change(-1)"
               alt="">
        </div> -->
        <div class="input_wrap">
          <div class="btn_wrap">
            <div style="display: flex;">
            <div :class="this.$parent.index == 0 ? 'disabled-btn' : 'btn'"
                  @click="change(-1)">
              上一题
            </div>
            <div :class="this.$parent.index == this.$parent.info.volist.length - 1 ? 'disabled-btn' : 'btn'"
                 @click="change(1)">
              下一题
            </div>
            </div>
            <div class="submit_btn"
                 @click="submitAll">
              提交试卷
            </div>
          </div>
        </div>
      </div>
    </div>
    <Form ref="FormRef" />
    <FeedBack ref="FeedBackRef" />
    <Tag ref="TagRef" />
  </div>
</template>

<script>
import Form from '@/views/discuss/components/form.vue'
import Tag from './tag.vue'
import { getBoard } from '@/api/discuss.js'
import { delCollect } from '@/api/errorbasis.js'
import FeedBack from './feedback.vue'
export default {
  data () {
    return {
      num: 0,
      activeNames: ['1', '2', '3', '4'],
      boardList: [],
      userInfo: {}
    }
  },
  props: {
    opertion_heigth: {
      type: Number,
      default: 240
    },
    question: {
      type: Object,
      default: () => {
        return {}
      }
    },
    images:{
      // type:Array,
      // default:[]
    }
  },
  computed: {
    userScore: {
      get() {
        return Number(this.question.user_score) || 0;
      },
      set(value) {
        this.$set(this.question, 'user_score', value);
      }
    }
  },
  components: {
    Form, FeedBack, Tag
  },
  mounted () {
    console.log(this.$parent.info)
    this.userInfo = JSON.parse(window.localStorage.getItem('userInfo'))
  },
  methods: {
    feed () {
      let form = {
        category: 0,
        comment: '',
        question_id: this.question.question_id,
        user_paper_detail_id: this.question.user_paper_detail_id,
        correct_type :this.$parent.info.correct_type,
      }
      this.$refs.FeedBackRef.form = form
      this.$refs.FeedBackRef.dialogVisible = true
    },
    handleChange () { },
    change (index) {
      this.$parent.change(index)
    },
    submitAll () {
      this.$parent.submitAll()
    },
    // 空方法 迁移过来的子组件触发使用
    initList () { },
    async addDiscuss () {
      if (this.boardList.length == 0) {
        const { data } = await getBoard()
        this.boardList = data
      }
      let form = {
        board_id: '',
        discuss_title: '',
        discuss_content: '',
        // question_id: this.$rands(this.question.question_id),
        question_id: this.question.question_id,

      }
      this.$refs.FormRef.dialogVisible = true
      this.$refs.FormRef.form = form
    },
    collect () {
      let form = {
        question_id: this.question.question_id,
        tags: ''
      }
      this.$refs.TagRef.dialogVisible = true
      this.$refs.TagRef.form = form
    },
    async cancelCollect () {
      this.$confirm("确定取消收藏这道题目？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        await delCollect({
          id: Number(this.question.question_favorite_id)
        })
        this.$message.success('取消收藏成功')
        this.question.has_favorite = 0
      }).catch(e => e)
    }
  }
}
</script>

<style lang="scss" scoped>
.el-image{
  position: static;
}
.opertion_wrap {
  // position: relative;
  height: 100%;
  .head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 68rem;
    padding: 24rem 40rem;
    background: #eff8ff;
    flex-wrap: wrap;
    .left {
      flex: 2;
      font-size: 20rem;
      font-weight: 500;
      color: #333333;
      display: flex;
      height: 36rem;
      flex-direction: column;
      justify-content: center;
      gap: 16rem;
      .my_score {
        margin-left: 24rem;
        flex: 1;
        font-size: 20rem;
        font-weight: 400;
        line-height: 24rem;
        color: #999;
        // margin-right: 30rem;
      }
    }
    .right {
      flex: 1;
      display: flex;
      // min-width: 310px;
      align-items: center;
      justify-content: flex-end;
      .img_warp{
        display: flex;
        gap: 30rem;
        font-size: 14rem;
        color: #3f9eff;
      }
      img {
        width: 38rem;
        height: 38rem;
        // margin-right: 30rem;
      }
    }
  }
  .content {
    width: calc(100% - 60rem);
    overflow: auto;
    background: #ffffff;
    margin-left: 30rem;
    .coll_wrap {
      margin-top: 30rem;
    }
  }
  .title {
  // margin-bottom: 20rem;
  font-size: 20rem;
  font-weight: 500;
  color: #666666;
  display: flex;
  // justify-content: space-between;
   flex-direction: column;
}
.topic_id {
color: var(--light-999999, #999);

font-size: 20rem;
font-style: normal;
font-weight: 400;
line-height: 30px; /* 150% */
}
.topic_id2{
color: var(--light-666666, #666);

font-size: 20rem;
font-style: normal;
font-weight: 400;
line-height: 30px; /* 150% */
}
  .fixed_btn {
    position: absolute;
    width: 100%;
    background: #ffffff;
    box-shadow: 0rem 2rem 10rem 4rem rgba(0, 0, 0, 0.05);
    border: 1rem solid #d9d9d9;
    bottom: 0;
    .line {
      margin-top: 20rem;
      display: flex;
      .label {
        font-size: 20rem;
        font-weight: bold;
        color: #000000;
        text-align: right;
        height: 50rem;
        line-height: 50rem;
        margin-left: 50rem;
        padding-right: 15rem;
        cursor: pointer;
        img {
          width: 50rem;
          height: 50rem;
        }
      }
      .input_wrap {
        flex: 1;
        .btn_wrap {
          display: flex;
          margin-right: 100rem;
          display: flex;
          justify-content: space-between;
          .disabled-btn {
            background: #F5F7FA;
            color: #C0C4CC;
            height: 50rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 20rem;
            font-weight: bold;
            border-radius: 25rem;
            cursor: not-allowed;
            &:nth-child(1) {
              width: 108rem;
              margin-left: 50rem;
              margin-right: 24rem;
            }
            &:nth-child(2) {
              width: 360rem;
            }
          }
          .btn {
            // flex: 1;
            height: 50rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 20rem;
            font-weight: bold;
            border-radius: 25rem;
            cursor: pointer;
            &:nth-child(1) {
              width: 108rem;
              margin-left: 50rem;
              margin-right: 24rem;
              background: none !important;
              border: 1px solid #3f9eff;
              color: #3f9eff;
            }
            &:nth-child(2) {
              width: 360rem;
              color: #ffffff;
              background: #3f9eff !important;
            }
          }
          .submit_btn {
            height: 50rem;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #ffffff;
            font-size: 20rem;
            font-weight: bold;
            border-radius: 25rem;
            width: 128rem;
            background: #fe765f;
            cursor: pointer;
          }
        }
      }
    }

    ::v-deep .el-input--medium .el-input__inner {
      height: 50rem;
      line-height: 50rem;
    }
    ::v-deep .el-input-number__decrease,
    .el-input-number__increase {
      height: 47rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    ::v-deep .el-input-number__increase {
      height: 47rem;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

::v-deep .el-collapse-item__header {
  background: #f6f6f6;
  border-radius: 10rem;
  font-size: 20rem;
  font-weight: 500;
  color: #333333;
  text-indent: 20rem;
  margin-top: 20rem;
}
::v-deep .el-collapse-item__wrap {
  border-bottom: none;
}
::v-deep .el-collapse {
  border: none;
}
::v-deep .el-collapse-item__content {
  margin-left: 20rem;
  margin-top: 20rem;
}
::v-deep .el-collapse-item__arrow.is-active {
  margin-top: -20rem;
}
.topic {
  font-size: 20rem;
}
</style>